// extracted by mini-css-extract-plugin
export default {"container":"Volume_container__cbx4N"};